export enum PrepaymentTypeEnum {
  BANK_TRANSFER = 'bank-transfer',
  DIRECT_DEBIT = 'direct-debit',
}
